import React, { useMemo } from 'react';

import { getCatalogFilterOptions } from 'components/fbm/components/partnerCatalog/partnerCatalogUtils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shadcn/components/ui/Tabs';

/**
 * Mutually exclusive catalog filter pills.
 *
 * @param {Object} props
 * @param {string} [props.fbmAccountName]
 * @param {string} props.value
 * @param {(next: string) => void} props.onValueChange
 * @param {string} [props.className]
 */
function PartnerCatalogFilterPills({ className, fbmAccountName, onValueChange, value }) {
    const options = useMemo(() => getCatalogFilterOptions(fbmAccountName), [fbmAccountName]);

    return (
        <Tabs className={className} value={value} onValueChange={onValueChange}>
            <TabsList className="w-fit">
                {options.map((option) => (
                    <TabsTrigger key={option.value} value={option.value}>
                        {option.label}
                    </TabsTrigger>
                ))}
            </TabsList>
            {options.map((option) => (
                <TabsContent key={option.value} value={option.value} className="hidden" aria-hidden tabIndex={-1} />
            ))}
        </Tabs>
    );
}

export { PartnerCatalogFilterPills };
